/*
  Delivery estimate countdown.

  Verbatim port of pages-2.jsx DeliveryEstimate (lines 4–48). Cutoff = 4pm
  USER LOCAL TIME (intentionally, matches prototype). Ship date skips
  weekends. Delivery = ship + 3 business days. Recomputes every 60 seconds.

  // PHASE 14 TZ Q: If the merchant later asks for shop-timezone anchoring
  // instead of user-local, swap `new Date()` for a shop-time computation
  // (e.g. via Intl.DateTimeFormat with timeZone: shop.timezone passed via
  // a data-attribute from main-product-delivery.liquid).
*/

(() => {
  const fmtShort = (d) =>
    d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }).toUpperCase();

  const render = () => {
    const root = document.querySelector('[data-delivery-countdown]');
    if (!root) return;
    const cutoffEl = root.querySelector('[data-delivery-cutoff]');
    const arrivesEl = root.querySelector('[data-delivery-arrives]');
    if (!cutoffEl || !arrivesEl) return;

    const now = new Date();

    // Cutoff = 4pm local. If past 4pm, ship next day; else ship today.
    const cutoff = new Date(now);
    cutoff.setHours(16, 0, 0, 0);

    let shipDate = new Date(now);
    if (now > cutoff) shipDate.setDate(shipDate.getDate() + 1);
    // Skip weekends for ship date
    while (shipDate.getDay() === 0 || shipDate.getDay() === 6) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // Delivery = ship + 3 business days
    let deliveryDate = new Date(shipDate);
    let added = 0;
    while (added < 3) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) added++;
    }

    const beforeCutoff = now < cutoff;
    const msLeft = cutoff - now;
    const hrs = Math.floor(msLeft / 3600000);
    const mins = Math.floor((msLeft % 3600000) / 60000);

    cutoffEl.textContent = beforeCutoff
      ? `ORDER IN ${hrs}H ${mins}M →`
      : 'ORDERS BY 4PM TOMORROW →';
    arrivesEl.textContent = `ARRIVES BY ${fmtShort(deliveryDate)}`;
  };

  const start = () => {
    render();
    setInterval(render, 60000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Re-render after Section Rendering API swap (product-page.js variant change).
  document.addEventListener('product:section-swapped', render);
})();
